<template>
  <div v-if="bot.exchangeId == 'bybit'">
    <p>
      To send funds to your Subaccount, go to your <a href="https://www.bybit.com/app/user/sub-account?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
    </p>
    <p>
      Click on <span class="fw-bold">Transfer</span> for the Subaccount in question.<br>
      Select the <span class="fw-bold">From</span> account where your funds are now.<br>
      Choose where to send the funds <span class="fw-bold">To</span> and make sure you choose the <span class="fw-bold">Unified Trading</span> account.<br>
      Click <span class="fw-bold">Confirm</span>.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_fund_account_v2.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_fund_account_v2.jpg" zoom="/exchanges/explainers/bybit_fund_account_v2.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'kraken'">
    <p>
      Kraken does not have diffrent account types, so as long as you have funds in your <a href="https://pro.kraken.com/app/portfolio/spot" target="_blank"><span class="fw-bold">Portfolio</span></a>, you are good to go.
    </p>
  </div>
  <div v-else-if="bot.exchangeId == 'binance'">
    <p>
      To send funds to your Sub Account, go to your Sub Accounts <a href="https://www.binance.com/en/my/sub-account/account-management/?ref=T7HMHDW5" target="_blank"><span class="fw-bold">Account Management</span></a> (left side menu).<br>
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_account_management.jpg" />

    <p>
      Click on the <span class="fw-bold">three dots</span> and select <span class="fw-bold">Transfer In</span> for the Sub Account in question.
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_transfer_in.jpg" />

    <p>
      Select the <span class="fw-bold">Transfer From</span> account where your funds are now.<br>
      Select the <span class="fw-bold">Sub Account</span> to <span class="fw-bold">Transfer To</span> and choose <span class="fw-bold">Spot</span>.<br>
      Choose the <span class="fw-bold">Coin</span> and the <span class="fw-bold">Amount</span> as needed.<br>
      Click <span class="fw-bold">Confirm</span>.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_transfer_funds.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/binance_transfer_funds.jpg" zoom="/exchanges/explainers/binance_transfer_funds.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'kucoin'">
    <p>
      To send funds to your Subaccount, go to your <a href="https://kcst.art/CJT1RCjcIyvY" target="_blank"><span class="fw-bold">Sub-Accounts</span></a>.
    </p>
    <p>
      Click on <span class="fw-bold">Transfer</span> for the Sub-Account in question.<br>
      Select the <span class="fw-bold">From</span> account where your funds are now.<br>
      Select the <span class="fw-bold">Trading Account</span> as your <span class="fw-bold">To</span> (not the Funding Account)!<br>
      Choose the <span class="fw-bold">Asset</span> and the <span class="fw-bold">Amount</span>.<br>
      Click <span class="fw-bold">Confirm</span>.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_transfer_funds.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/kucoin_transfer_funds.jpg" zoom="/exchanges/explainers/kucoin_transfer_funds.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'coinbase'">
    <p>
      To send funds to your Portfolio, go to your <a href="https://www.coinbase.com/advanced-portfolio" target="_blank"><span class="fw-bold">Portfolios</span></a> and click on the one you need.<br>
      Click on <span class="fw-bold">Transfer in</span> and follow the flow.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_fund_account.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/coinbase_fund_account.jpg" zoom="/exchanges/explainers/coinbase_fund_account.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'mexc'">
    <p>
      To send funds to your Sub Account, go to <a href="https://www.mexc.com/user/sub-account?tab=assets&shareCode=mexc-signum" target="_blank"><span class="fw-bold">Asset Management</span></a>.<br>
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_asset_management.jpg" />

    <p>
      Click on <span class="fw-bold">Transfer</span> for the Subaccount in question.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_click_transfer.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/mexc_click_transfer.jpg" zoom="/exchanges/explainers/mexc_click_transfer.jpg" />

    <p>
      Select the <span class="fw-bold">Sending Account</span> account where your funds are now.<br>
      Select the <span class="fw-bold">Receiving Account</span> (aka. your Subaccount) and choose <span class="fw-bold">Spot</span>.<br>
      Choose the <span class="fw-bold">Coin</span> and the <span class="fw-bold">Amount</span> as needed.<br>
      Click <span class="fw-bold">Transfer</span>.
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_transfer_funds_form.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'bitget'">
    <p>
      To send funds to your Sub-account, go to your <a href="https://www.bitget.com/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.
    </p>
    <p>
      Click on <span class="fw-bold">Transfer</span> for the Sub-account in question.<br>
      Select the <span class="fw-bold">From</span> account where your funds are now.<br>
      Select the <span class="fw-bold">Sub-account</span> and <span class="fw-bold">Spot</span> as your <span class="fw-bold">To</span> destination.<br>
      <span class="fw-bold">Select a coin</span> and the <span class="fw-bold">Transfer amount</span>.<br>
      Click <span class="fw-bold">Confirm</span>.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_transfer_funds.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bitget_transfer_funds.jpg" zoom="/exchanges/explainers/bitget_transfer_funds.jpg" />

  </div>
  <div v-else-if="bot.exchangeId == 'cryptodotcom'">
    <p>
      To send funds to your Sub-account, first <span class="fw-bold">switch back to your Master Account</span>.
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_switch_to_master_account.jpg" />
    
    <p>
      Go to <a href="https://crypto.com/exchange/user/account-management" target="_blank"><span class="fw-bold">Manage Account</span></a>.
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_manage_account_menu.jpg" />
                        
    <p>
      Click on <span class="fw-bold">Transfer</span> for the Sub-account in question.<br>
      Select the <span class="fw-bold">Transfer From</span> account where your funds are now.<br>
      Select the <span class="fw-bold">Sub-account</span> as your <span class="fw-bold">Transfer To</span> destination.<br>
      <span class="fw-bold">Select a coin</span> and the <span class="fw-bold">Amount</span>.<br>
      Click <span class="fw-bold">Review</span>.
    </p>
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/cryptocom_transfer_funds.jpg" zoom="/exchanges/explainers/cryptocom_transfer_funds.jpg" />
  </div>
  <div v-else-if="bot.exchangeId == 'hyperliquid'">
    <p>
      To send funds to your Account, click on the <b>Deposit</b> button from the top menu.
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_deposit_button.jpg" />
    
    <hr>

    <p>
      It's best to send <b>USDC</b> (only USDC) on the <b>Arbitrum</b> network to the address shown. This is the safest way to fund your account.<br>
      <br>
      You can <b>send USDC from your CEX (Bybit, Coinbase, etc.)</b>, just make sure to send it on the <b>Arbitrum network</b>.<br>
      This way you don't need to use a wallet if you don't want to. 
    </p>
    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_fund_on_arbitrum.jpg" />

    <hr>

    <p>
      Go to the <a href="https://app.hyperliquid.xyz/trade" target="_blank"><b>Trade interface</b></a> and click on <b>Balances</b> to see your funds.<br>
      This is where you'll find the funds you've deposited.<br>
      <br>
      The <b>Available Balance</b> show the available funds you can trade with. This also is the number SIGNUM will show you.
    </p>
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="3" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/hype_balances.jpg" zoom="/exchanges/explainers/hype_balances.jpg" />

    <hr>

    <div v-if="bot.tradingAccount == 'spot'">
      <p>
        For <b>Spot Bots</b> make sure your funds are on the <b>Spot Account</b>, otherwise your Spot Bot won't find the funds to trade with.<br>
        Go to your <a href="https://app.hyperliquid.xyz/portfolio" target="_blank"><b>Portfolio</b></a> and click on <b>Perps &#8646; Spot Transfer</b>.<br>
        Choose the amount to transfer and click on <b>Confirm</b><br>
        <br>
        If you see <b>USDC (Spot)</b> in your Balances, you did it correctly.
      </p>
      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/hype_perp_to_spot_transfer.jpg" zoom="/exchanges/explainers/hype_perp_to_spot_transfer.jpg" />
    </div>
  </div>
  <div v-else-if="bot.exchangeId == 'gate'">
    <p>
      To send funds to your Subaccount, go to your <a href="https://www.gate.com/myaccount/sub_account_manage" target="_blank"><span class="fw-bold">Subaccounts</span></a>.
    </p>
    <p>
      Click on <span class="fw-bold">Transfer</span> for the Subaccount in question.<br>
      Fill in the form as needed and click <span class="fw-bold">Confirm</span>.
    </p>
    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_transfer_funds.jpg" /> -->
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/gate_fund_account_form_smaller.jpg" zoom="/exchanges/explainers/gate_fund_account_form_smaller.jpg" />
  </div>
  <div v-else-if="['okx', 'okxus', 'okxeea'].includes(bot.exchangeId)">
    <p>
      To send funds to your Subaccount, go to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.<br>
      Click on <span class="fw-bold">Transfer</span> for the Subaccount in question.
    </p>
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_tranfer_button.jpg" zoom="/exchanges/explainers/okx_tranfer_button.jpg" />

    <p>
      Make sure the right <span class="fw-bold">Sub-account</span> is selected.<br>
      Fill in the form as needed.<br>
      Click <span class="fw-bold">Transfer</span>.
    </p>
    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_transfer_form.jpg" zoom="/exchanges/explainers/okx_transfer_form.jpg" />
  </div>
  <div v-else>
    <p>
      Ooops, we forgot to add the info for this exchange 🤦🏼‍♂️<br>
      Please come to our <a :href="getSupportUrl()" target="_blank">Telegram Group</a> and let us know.
    </p>
  </div>

  
</template>

<script>
import { VueImageZoomer } from 'vue-image-zoomer' // https://www.npmjs.com/package/vue-image-zoomer
export default {
  props: {
    bot: {
      required: true,
      type: Object
    }
  },
  components: {
    VueImageZoomer
  },
  methods: {
    getSupportUrl () {
      return process.env.VUE_APP_SUPPORT_URL
    }
  }
}
</script>

<style scoped>

</style>